import "react-circular-progressbar/dist/styles.css";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import styled from "styled-components";

import { ArrowLeftColor, SharedInput } from "@components";
import { PATH_HOME, PATH_LIST_OF_WINNER } from "@configs";
import { IMemberTier } from "@interfaces";
import { selectAuth, selectMerchant } from "@redux";
import PageSimpleWheel from "@Rocket-Innovation/components/app/console/spin-wheel/page";
import { RenderMeta } from "@utils";
import { useEffect, useState } from "react";
import { useFullScreen } from "src/Helpers/useFullscreen";
import UIStore from "src/Store/UIStore";
import { WrapperSpinWheel } from "./ContentSpinWheel";
import { IconPoint } from "./icon/IconPoint";
import { IconTicket } from "./icon/IconTicket";
import { GlowTextReward, GlowTitle } from "./shared/GlowTitle";
import { ResultSpin } from "./shared/ResultSpin";
import { RewardSpin } from "./shared/RewardSpin";

interface IProps {
    avatar: string;
    fullName: string;
    memberTier: IMemberTier | undefined;
    isConfirm?: boolean;
}

export const ComponentSpinWheel = (props: IProps) => {
    //page hook
    const { t } = useTranslation();
    //push route
    const history = useHistory();
    //redux statex
    const { userInfo } = useSelector(selectAuth);
    const { themes } = useSelector(selectMerchant);
    const merchant = useSelector(selectMerchant);

    // const [surveyList, setSurveyList] = useState<ISurvey[]>([]);
    const [viewportHeight, setViewportHeight] = useState(0);
    const dispatch = useDispatch();
    const fullHeight = useFullScreen();
    const [showpopupinvite, setShowPopupInvite] = useState<boolean>(false);
    const [showInfo, setShowInfo] = useState<boolean>(false);

    useEffect(() => {
        setViewportHeight(window.innerHeight);
    }, []);

    const click = () => {
        UIStore.setState({
            useDrawer: true,
            unsetDrawer: true,
            drawerContent: <ContentPopup />,
        });
    };

    const ContentPopup = () => {
        return <ResultSpin themeColor={themes?.themeColor!} />;
    };

    const clicks = () => {
        UIStore.setState({
            useDrawer: true,
            drawerContent: <RedeemDrawer />,
        });
    };

    const RedeemDrawer = () => {
        const { t } = useTranslation();

        return (
            <StyledRedeemDrawer themeColor={themes?.themeColor!}>
                <h3>{t("Redeem Point for Ticket")}</h3>
                <div className="wrapper-content-ticket">
                    <div className="ticket-point-container">
                        <div className="ticket-section">
                            <span className="label">
                                <IconTicket />
                                {t("Ticket")}
                            </span>
                            <div className="value">
                                <SharedInput defaultValue={1} />
                                <span className="textinput">Ticket</span>
                            </div>
                        </div>
                        <div className="equals">=</div>
                        <div className="point-section">
                            <span className="label">
                                <IconPoint />
                                {t("Point")}
                            </span>
                            <div className="value">
                                <SharedInput defaultValue={5} disable />
                                <span className="textinput">Points</span>
                            </div>
                        </div>
                    </div>
                    <div className="options">
                        <button>1 Ticket</button>
                        <button>5 Tickets</button>
                        <button disabled>10 Tickets</button>
                        <button disabled>20 Tickets</button>
                    </div>
                </div>
                <div className="desc-redeem-drawer">
                    <p className="info">
                        You have: 25 Points <span>(expire: 12/03/2567)</span>
                    </p>
                    <p className="info">Can redeem up to 5 Tickets</p>
                </div>

                <button className="redeem-button">{t("Redeem")}</button>
            </StyledRedeemDrawer>
        );
    };

    console.log("merchant", merchant);
    console.log("userInfo", userInfo);

    return (
        <>
            <RenderMeta title={t("meta.luckydraw_page")} />
            <StyledSpinWheel
                style={{ height: fullHeight }}
                themeColor={themes?.themeColor!}
                bgImg="../../images/bg-spin-wheel.svg"
                contentColor={merchant?.luckyDrawDisplaySetting?.textColor!}
                themePageColor={merchant?.luckyDrawDisplaySetting?.themeColor!}
            >
                <header>
                    <div className="back-arrow">
                        <ArrowLeftColor
                            onClick={() => history.push(PATH_HOME)}
                            color={merchant?.luckyDrawDisplaySetting?.themeColor}
                        />
                    </div>
                </header>
                <GlowTitle text="Spin Wheel" />
                <div className="winner-spinwheel">
                    <span className="layout">
                        <div className="img-winner-spinwheel">
                            <img src="../../images/ic-user-spinwheel.svg" alt="" />
                        </div>
                        <div className="name-winner-spinwheel">Nich****</div>
                    </span>
                    <span className="layout">
                        <div className="reward-winner-spinwheel">Get Coupon 20%</div>
                        <div
                            className="link-spinwheel"
                            onClick={() => history.push(PATH_LIST_OF_WINNER)}
                        >
                            <img src="../../images/arrow-spinwheel.svg" alt="" />
                        </div>
                    </span>
                </div>
                <div
                    className="info-spin"
                    onClick={() => {
                        setShowInfo(true);
                    }}
                >
                    <img src="../../images/info-spin.svg" alt="" />
                </div>
                <div className="control-spin">
                    <PageSimpleWheel />
                </div>
                <div className="control-content">
                    <div className="wrapper-center">
                        <div className="total-ticket-spin">
                            <span>
                                <IconTicket color="#fff" />
                            </span>
                            1 Ticket left
                        </div>
                        <div className="text-ticket-spin">
                            <span className="first">Limit Ticket (Day) : 1/5</span>
                            <span>Limit Ticket (Duration) : 1/20</span>
                        </div>
                    </div>

                    {/* <div className="simple-box-spin"></div> */}
                    <WrapperSpinWheel clicks={clicks} />
                </div>
                <button onClick={click}> Click</button>
                <button onClick={clicks}> Clicks</button>
                <button
                    onClick={() => {
                        setShowPopupInvite(true);
                    }}
                >
                    {" "}
                    Click popup
                </button>
            </StyledSpinWheel>
            {showInfo ? (
                <StyledSpinInfo themeColor={themes?.themeColor!}>
                    <div className="box-info">
                        <div className="content-info">
                            <div className="title-info">
                                Terms & Conditions for Spin Wheel Participation
                            </div>
                            <div className="desc-info">
                                <p>
                                    1. Eligibility: Only registered customers are eligible to
                                    participate in the Spin Wheel campaign. Each participant must
                                    meet the specific requirements outlined by the company.
                                </p>
                                <p>
                                    2. Spin Limits: Participants are limited to a specified number
                                    of spins per day, as determined by the campaign rules.
                                </p>
                                <p>
                                    3. Rewards and Prizes: All rewards won through the Spin Wheel
                                    are non-transferable and cannot be exchanged for cash. The type
                                    and quantity of prizes are subject to availability.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div
                        className="close-popupinvite"
                        onClick={() => {
                            setShowInfo(false);
                        }}
                    >
                        <img src="../images/ic-close-invite.svg" alt="" />
                    </div>
                </StyledSpinInfo>
            ) : null}
            {showpopupinvite ? (
                <StyledPopupInvite themeColor={themes?.themeColor!}>
                    <GlowTextReward text="Congratulation" textsub="you get" />
                    <div className="box-popupinvite">
                        <div className="sub-reward">
                            <img src="../../images/img-rewardbox.svg" alt="" />
                        </div>
                        <div className="detail-popupinvite">
                            <RewardSpin
                                imgReward="../../images/img-discount.svg"
                                titleReward="Robinhood 20% Off"
                                totleReward="x3 Coupons"
                                textButton="See Reward"
                            />
                        </div>
                    </div>
                    <div
                        className="close-popupinvite"
                        onClick={() => {
                            setShowPopupInvite(false);
                        }}
                    >
                        <img src="../images/ic-close-invite.svg" alt="" />
                    </div>
                </StyledPopupInvite>
            ) : null}
        </>
    );
};

const StyledRedeemDrawer = styled.div<{ themeColor: string }>`
    padding: 20px;
    background-color: #fff;
    border-radius: 8px;
    text-align: center;

    h3 {
        font-size: 20px;
        font-weight: 600;
        margin-bottom: 20px;
    }
    .wrapper-content-ticket {
        background-color: #f9f9f9;
        padding: 15px;
        border-radius: 16px;
        position: relative;
        .ticket-point-container {
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 20px;
            padding: 15px 0 30px;
            border-bottom: 1px dotted #ddd;
            position: relative;
            &::after {
                position: absolute;
                content: "";
                width: 40px;
                height: 40px;
                border-radius: 100%;
                background-color: rgb(255, 255, 255);
                bottom: -20px;
                left: -30px;
            }
            &::before {
                position: absolute;
                content: "";
                width: 40px;
                height: 40px;
                border-radius: 100%;
                background-color: rgb(255, 255, 255);
                bottom: -20px;
                right: -30px;
            }
            .ticket-section,
            .point-section {
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                .label {
                    font-size: 14px;
                    line-height: 17px;
                    svg {
                        margin-right: 5px;
                    }
                }
                .value {
                    font-size: 24px;
                    font-weight: bold;
                    margin: 5px 0;
                    position: relative;
                    input {
                        padding-right: 75px !important;
                    }
                    span.textinput {
                        position: absolute;
                        right: 15px;
                        top: 15px;
                        font-size: 14px;
                        line-height: 17px;
                        color: #000;
                    }
                }
            }

            .equals {
                margin: 0 10px;
                font-size: 24px;
                position: relative;
                top: 7px;
            }
        }

        .options {
            display: flex;
            justify-content: space-around;
            padding: 15px 0;
            button {
                background-color: #fff;
                border: none;
                padding: 10px 10px;
                border-radius: 5px;
                cursor: pointer;
                font-size: 14px;
                border-radius: 8px;
                border: 1px solid #9b9b9b;
                &:disabled {
                    background-color: #ddd;
                    color: #999;
                    cursor: not-allowed;
                }
            }
        }
    }
    .desc-redeem-drawer {
        margin: 15px 0;
        .info {
            font-size: 12px;
            color: #000;
            margin-bottom: 5px;
            span {
                font-size: 10px;
                color: #9b9b9b;
            }
        }
    }

    .redeem-button {
        width: 100%;
        padding: 15px 0;
        background-color: ${(p) => p.themeColor};
        color: #fff;
        border: none;
        border-radius: 16px;
        font-size: 16px;
        font-weight: 600;
    }
`;

const StyledSpinWheel = styled.div<{
    themeColor: string;
    bgImg: string;
    contentColor: string;
    themePageColor: string;
}>`
    width: 100%;
    margin: 0 auto;
    padding: 15px;
    height: 100vh;
    overflow: scroll;
    background-color: #fff;
    background-position: center top;
    background-repeat: no-repeat;
    background-image: ${(props) =>
        props?.bgImg !== "" ? `url(${props?.bgImg})` : "../../images/bg-spin-wheel.svg"};
    background-image: "../../images/bg-spin-wheel.svg";
    background-size: cover;
    position: relative;
    .logo-survey {
        font-size: 32px;
        color: ${(p) => p.themeColor};
        font-weight: 600;
    }
    .back-arrow {
        position: absolute;
        left: 10px;
        display: flex;
        span {
            margin-left: 10px;
            color: ${(props) =>
                props?.themePageColor !== "" ? `${props?.themePageColor}` : "#fff"};
        }
    }
    header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px;
        .title-group {
            text-align: center;
        }
        h4 {
            flex: 1;
            display: flex;
            justify-content: center;
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 25px;
            color: #000000;
        }
    }
    .info-spin {
        position: absolute;
        right: 15px;
        top: 50px;
    }
    .wrapper-center {
        text-align: center;
    }
    .total-ticket-spin {
        background: linear-gradient(0deg, rgba(0, 0, 0, 0.64) 0%, rgba(0, 0, 0, 0.64) 100%), #fe7b57;
        color: #fff;
        place-items: center;
        -webkit-box-align: center;
        gap: 10px;
        display: inline-block;
        padding: 5px 15px;
        border-radius: 16px;
        margin-bottom: 15px;
        border: var(--2-px, 2px) solid #e94e3c;
        /* border: 3px solid #ECA489; */
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) inset;
        span {
            margin-right: 5px;
        }
    }
    .text-ticket-spin {
        font-size: 12px;
        color: #fff;
        line-height: 20px;
        display: flex;
        gap: 15px;
        align-items: center;
        justify-content: center;
        margin-bottom: 15px;
        position: relative;
        span.first {
            position: relative;
            &::after {
                content: "";
                width: 1px;
                height: 15px;
                position: absolute;
                background-color: #fff;
                top: 5px;
                right: -8px;
            }
        }
    }

    .control-spin {
        position: relative;
        width: 100%;
        height: 450px;
        margin-bottom: 30px;
        > div {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 1;
        }
    }
    .control-content {
        position: relative;
        z-index: 1;
    }
    .winner-spinwheel {
        border-radius: 80px;
        width: 250px;
        padding: 3px;
        background: linear-gradient(
            90deg,
            rgba(255, 255, 255, 1) 0%,
            rgba(255, 255, 255, 0.2) 100%
        );
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 5px;
        margin: 0 auto;
        margin-bottom: 30px;
        span.layout {
            display: flex;
            gap: 10px;
            align-items: center;
        }
    }
    .simple-box-spin {
        height: 450px;
        background-color: #000;
        margin-bottom: 30px;
        opacity: 0.5;
    }
`;

const StyledSpinInfo = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    flex-direction: column;
    .box-info {
        // background: ${(p) => p.theme.colors.card};
        background: #fff;
        /* background: linear-gradient(0deg, rgba(255, 255, 255, 1) 70%, rgba(196, 163, 99, 1) 100%); */
        background-image: url(../../images/bg-spininfo-01.svg);
        background-repeat: no-repeat;
        background-size: cover;
        padding: 100px 28px 28px;
        border-radius: 16px;
        width: calc(100% - 80px);
        max-height: 90%;
        overflow: inherit;
        position: relative;
        margin-bottom: 40px;
        min-height: 500px;
        .content-info {
            background-color: #fff;
            padding: 16px;
            border-radius: 16px;
            width: calc(100% - 32px);
            position: absolute;
            top: 200px;
            left: 16px;
            height: 285px;
            overflow: scroll;
            .title-info {
                font-size: 14px;
                line-height: 17px;
                color: #000;
                font-weight: 600;
                text-align: center;
                margin-bottom: 15px;
            }
            .desc-info {
                p {
                    font-size: 12px;
                    line-height: 20px;
                    color: #616161;
                    margin-bottom: 15px;
                }
            }
        }
        ::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        animation: shakebox 0.3s !important;
        @keyframes shakebox {
            0% {
                top: 0px;
                left: 0px;
            }
            25% {
                top: -5px;
                left: -5px;
            }
            50% {
                top: 0;
                left: 0;
            }
            75% {
                top: 5px;
                left: 5px;
            }
            100% {
                top: 0;
                left: 0;
            }
        }
        .detail-popupinvite {
            /* border-bottom: 0.5px solid #c0cbde; */
            position: relative;
            .desc-popupinvite {
                font-size: 16px;
                line-height: 23px;
                color: #9b9b9b;
                margin-bottom: 30px;
                text-align: center;
            }
            .input-popupinvite {
                position: relative;
                padding-right: 90px;
                margin-bottom: 20px;
                input {
                    min-height: 48px !important;
                    border-radius: 0;
                    border-top-left-radius: 14px;
                    border-bottom-left-radius: 14px;
                    border-top-right-radius: 0 !important;
                    border-bottom-right-radius: 0 !important;
                    border-color: ${(p) => p.themeColor};
                    font-size: 13px;
                }
                .submit {
                    position: absolute;
                    width: 90px;
                    height: 48px;
                    right: 0;
                    top: 0;
                    border-radius: 0;
                    border-top-right-radius: 14px;
                    border-bottom-right-radius: 14px;
                    background-color: ${(p) => p.themeColor};
                    border-color: ${(p) => p.themeColor};
                    padding-left: 35px;
                    background-image: url(../../images/ic-copy.svg);
                    background-size: 14px;
                    background-repeat: no-repeat;
                    background-position: 16px center;
                }
            }
            .center-qr {
                text-align: center;
            }
        }
        .share-popupinvite {
            text-align: center;
            padding: 16px 0 0;
            a {
                color: ${(p) => p.themeColor};
                font-size: 13px;
                line-height: 16px;
                font-weight: 600;
                /* padding-left: 26px; */
                /* background-image: url(../../images/ic-share.svg); */
                background-size: 16px;
                background-repeat: no-repeat;
                background-position: left center;
                svg {
                    margin-right: 10px;
                }
            }
        }
    }
    .close-popupinvite {
        img {
            width: 32px;
        }
    }
`;

const StyledPopupInvite = styled.div<{ themeColor: string }>`
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: 480px;
    background: rgba(0, 0, 0, 0.5);
    flex-direction: column;
    .box-popupinvite {
        // background: ${(p) => p.theme.colors.card};
        background: #fff;
        /* background: linear-gradient(0deg, rgba(255, 255, 255, 1) 70%, rgba(196, 163, 99, 1) 100%); */
        padding: 100px 28px 28px;
        border-radius: 8px;
        width: calc(100% - 80px);
        max-height: 90%;
        overflow: inherit;
        position: relative;
        margin-bottom: 40px;
        ::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        animation: shakebox 0.3s !important;
        @keyframes shakebox {
            0% {
                top: 0px;
                left: 0px;
            }
            25% {
                top: -5px;
                left: -5px;
            }
            50% {
                top: 0;
                left: 0;
            }
            75% {
                top: 5px;
                left: 5px;
            }
            100% {
                top: 0;
                left: 0;
            }
        }
        .img-popupinvite {
            position: absolute;
            top: -100px;
            left: 50%;
            transform: translateX(-50%);
            img {
                width: 100%;
                max-width: 150px;
            }
        }
        .sub-reward {
            margin-top: -100px;
            position: absolute;
            top: 0;
            width: calc(100% + 32px);
            left: -16px;
            img {
                width: 100%;
                height: auto;
            }
        }
        .detail-popupinvite {
            /* border-bottom: 0.5px solid #c0cbde; */
            position: relative;
            .desc-popupinvite {
                font-size: 16px;
                line-height: 23px;
                color: #9b9b9b;
                margin-bottom: 30px;
                text-align: center;
            }
            .input-popupinvite {
                position: relative;
                padding-right: 90px;
                margin-bottom: 20px;
                input {
                    min-height: 48px !important;
                    border-radius: 0;
                    border-top-left-radius: 14px;
                    border-bottom-left-radius: 14px;
                    border-top-right-radius: 0 !important;
                    border-bottom-right-radius: 0 !important;
                    border-color: ${(p) => p.themeColor};
                    font-size: 13px;
                }
                .submit {
                    position: absolute;
                    width: 90px;
                    height: 48px;
                    right: 0;
                    top: 0;
                    border-radius: 0;
                    border-top-right-radius: 14px;
                    border-bottom-right-radius: 14px;
                    background-color: ${(p) => p.themeColor};
                    border-color: ${(p) => p.themeColor};
                    padding-left: 35px;
                    background-image: url(../../images/ic-copy.svg);
                    background-size: 14px;
                    background-repeat: no-repeat;
                    background-position: 16px center;
                }
            }
            .center-qr {
                text-align: center;
            }
        }
        .share-popupinvite {
            text-align: center;
            padding: 16px 0 0;
            a {
                color: ${(p) => p.themeColor};
                font-size: 13px;
                line-height: 16px;
                font-weight: 600;
                /* padding-left: 26px; */
                /* background-image: url(../../images/ic-share.svg); */
                background-size: 16px;
                background-repeat: no-repeat;
                background-position: left center;
                svg {
                    margin-right: 10px;
                }
            }
        }
    }
    .close-popupinvite {
        img {
            width: 32px;
        }
    }
`;
